// Вставка надиктованного текста в поле ввода в позицию курсора (или вместо
// выделения), а не поверх всего содержимого: ученик может ткнуть в нужное
// место строки и додиктовать. Чистая функция — проверяется тестами.

export type Caret = { start: number; end: number }

export type SplicedDictation = { text: string; caret: number }

// base — текущее содержимое поля; caret — куда вставлять (null — в конец);
// piece — распознанный текст. Между вставкой и соседями добавляется пробел,
// если его там нет; вокруг пустого piece ничего не меняется.
export function spliceDictation(base: string, caret: Caret | null, piece: string): SplicedDictation {
  const p = piece.trim()
  const start = caret ? Math.max(0, Math.min(caret.start, base.length)) : base.length
  const end = caret ? Math.max(start, Math.min(caret.end, base.length)) : base.length
  if (!p) return { text: base, caret: end }
  const before = base.slice(0, start)
  const after = base.slice(end)
  const lead = before && !/\s$/.test(before) ? ' ' : ''
  const trail = after && !/^\s/.test(after) ? ' ' : ''
  const inserted = `${lead}${p}${trail}`
  return { text: `${before}${inserted}${after}`, caret: before.length + lead.length + p.length }
}
